/**
 * Display category of an investment program, for colouring the canvas.
 *
 * A front-end constant on purpose, and only for display: nothing in `InvestmentProgramDetail`
 * that the canvas reads today carries a grouping, and the recommendation engine never
 * consults one. When the program table grows a field that says the same thing, this map
 * becomes the fallback for names it does not cover — which is also what happens today to a
 * name typed into a rule that is not in the catalogue (`other`).
 */
export type ProgramCategory = 'ppa' | 'fund' | 'map' | 'start' | 'poc' | 'other';

export const PROGRAM_CATEGORY_META: Record<ProgramCategory, { label: string; color: string }> = {
  ppa: { label: 'PPA / 定价', color: '#2563eb' },
  fund: { label: 'Funding / 专项', color: '#c2410c' },
  map: { label: 'MAP 迁移', color: '#047857' },
  start: { label: '初创 / GFD', color: '#be185d' },
  poc: { label: 'PoC', color: '#7c3aed' },
  other: { label: '其它', color: '#475569' },
};

/** Exported so a test can require an entry for every catalogue program. */
export const CATEGORY_OF: Readonly<Record<string, ProgramCategory>> = {
  'SCE-led Cross Service PPA': 'ppa',
  'Seller-led Cross Service PPA': 'ppa',
  'SCE-led Service Specific PPA': 'ppa',
  'Seller-led Service Specific PPA': 'ppa',
  'R-PPA': 'ppa',
  'SPP Refund or SP Benefit': 'ppa',
  'VIP Funding': 'fund',
  'Compete Funding': 'fund',
  'T2K Winroom': 'fund',
  ACDC: 'fund',
  'Mainframe Must Win': 'fund',
  'AWS Global Passport (ISV)': 'fund',
  'China Regions acquire new': 'fund',
  'MAP 2.0': 'map',
  'MAP Lite': 'map',
  'GCR MAP': 'map',
  'MAP for SAP & Oracle': 'map',
  'VMware MAP': 'map',
  'DB & Analytics MAP': 'map',
  'Greenfield FastStart': 'start',
  'GCR Activate': 'start',
  'GCR Hot Startup': 'start',
  'IVT Solution PoC': 'poc',
  'GenAI Service PoC': 'poc',
  'Non GenAI Service PoC': 'poc',
  'Partner Solution PoC': 'poc',
  'General Platform Adoption PoC (Sales PoC)': 'poc',
  'Good Will Credit': 'other',
};

export function programCategoryOf(name: string): ProgramCategory {
  return CATEGORY_OF[name] ?? 'other';
}

export function programColorOf(name: string): string {
  return PROGRAM_CATEGORY_META[programCategoryOf(name)].color;
}
